import { getUser } from '@frontend/auth-helpers';

const DEMO_ACCOUNT_SUFFIX = ['@demoweave.com'];

export const useCheckAiReceptionistDemoAccount = () => {
  const user = getUser();

  return DEMO_ACCOUNT_SUFFIX.some((suffix) => user?.username?.endsWith(suffix));
};
